import { ConfigLine } from 'z3k-parser/parser/utils/object-line';
export class DeleteObjectLine extends ConfigLine {
    objectId;
    constructor(objectId) {
        super();
        this.objectId = objectId;
    }
    toString() {
        return `#Z${this.objectId}~`;
    }
}
export class SettingLine extends ConfigLine {
    settingId;
    value;
    constructor(settingId, value) {
        super();
        this.settingId = settingId;
        this.value = value;
    }
    toString() {
        return `#S${this.settingId}=${this.value}`;
    }
}
export const authorBits = (author_id) => author_id << 12;
export class CounterLine extends ConfigLine {
    author;
    value;
    constructor(author, value) {
        super();
        this.author = author;
        this.value = value;
    }
    toString() {
        return `#Z${authorBits(this.author) | this.value}=*`;
    }
}
export class UnknownLine extends ConfigLine {
    content;
    constructor(content) {
        super();
        this.content = content;
    }
    toString() {
        return `${this.content}`;
    }
}
export class TypeCastError extends Error {
}
export class Z3KConfigParserError extends Error {
}
export var Z3KConfigSettingNumber;
(function (Z3KConfigSettingNumber) {
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["device"] = 7] = "device";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["gsm_settings"] = 12] = "gsm_settings";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["timezone"] = 36] = "timezone";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["port_rs485"] = 124] = "port_rs485";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["a300_diag_interface"] = 180] = "a300_diag_interface";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["a300_diag_available_params"] = 181] = "a300_diag_available_params";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["servers"] = 200] = "servers";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["port"] = 201] = "port";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["login"] = 202] = "login";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["apn"] = 203] = "apn";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["usb_password"] = 204] = "usb_password";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["gsm_settings_notification"] = 206] = "gsm_settings_notification";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["service_contact"] = 207] = "service_contact";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["wifi_settings"] = 208] = "wifi_settings";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["use_reserve_battery"] = 209] = "use_reserve_battery";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["stock_config"] = 211] = "stock_config";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["server_settings"] = 212] = "server_settings";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["local_subnet_name"] = 214] = "local_subnet_name";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["mqtt_address"] = 217] = "mqtt_address";
    Z3KConfigSettingNumber[Z3KConfigSettingNumber["wifi_access_point"] = 218] = "wifi_access_point";
})(Z3KConfigSettingNumber || (Z3KConfigSettingNumber = {}));
export const Z3KConfigSettingTypes = {
    device: Z3KConfigSettingNumber.device,
    gsm_settings: Z3KConfigSettingNumber.gsm_settings,
    timezone: Z3KConfigSettingNumber.timezone,
    port_rs485: Z3KConfigSettingNumber.port_rs485,
    a300_diag_interface: Z3KConfigSettingNumber.a300_diag_interface,
    a300_diag_available_params: Z3KConfigSettingNumber.a300_diag_available_params,
    servers: Z3KConfigSettingNumber.servers,
    port: Z3KConfigSettingNumber.port,
    login: Z3KConfigSettingNumber.login,
    apn: Z3KConfigSettingNumber.apn,
    usb_password: Z3KConfigSettingNumber.usb_password,
    gsm_settings_notification: Z3KConfigSettingNumber.gsm_settings_notification,
    service_contact: Z3KConfigSettingNumber.service_contact,
    wifi_settings: Z3KConfigSettingNumber.wifi_settings,
    use_reserve_battery: Z3KConfigSettingNumber.use_reserve_battery,
    stock_config: Z3KConfigSettingNumber.stock_config,
    server_settings: Z3KConfigSettingNumber.server_settings,
    local_subnet_name: Z3KConfigSettingNumber.local_subnet_name,
    mqtt_address: Z3KConfigSettingNumber.mqtt_address,
    wifi_access_point: Z3KConfigSettingNumber.wifi_access_point,
};
export const Z3KConfigSettingTypesNumber = Object.values(Z3KConfigSettingTypes);
